import { render } from "./EduPage.vue?vue&type=template&id=2dfc416c"
import script from "./EduPage.vue?vue&type=script&lang=js"
export * from "./EduPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__